/* eslint-disable react/destructuring-assignment */
import styled from '@emotion/styled'
import { Component } from 'react'

import { Slider, TextInput } from '../../atoms'

export type SliderWithTextInputProps = {
  'data-testid'?: string
  max?: number
  min?: number
  onChange?: (value: string) => void
  step?: number
  value?: number
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const SliderWrapper = styled.div`
  flex-grow: 1;
  padding-right: 16px;
`

const TextInputWrapper = styled.div`
  width: 60px;
`

const StyledTextInput = styled(TextInput)`
  text-align: center;
  padding: 10px;
`

// TODO: add tests:...
// when slider value changes, textbox should update
// if textbox is changed, it should check it's within range
//   if not within range, show error, don't update slider value
//   if within range, update slider value

type State = {
  isInvalid: boolean
  max: number
  min: number
  sliderValue: number
  step: number
  textValue: string
}

export class SliderWithTextInput extends Component<SliderWithTextInputProps, State> {
  private isUpdating: boolean

  constructor(props: SliderWithTextInputProps) {
    super(props)
    this.isUpdating = false
    this.handleSliderValueChange = this.handleSliderValueChange.bind(this)
    this.handleTextInputChange = this.handleTextInputChange.bind(this)

    this.state = {
      min: props.min || 0,
      max: props.max || 100,
      step: props.step || 1,
      textValue: (props.value && props.value.toString()) || '0',
      sliderValue: props.value || 0,
      isInvalid: false
    }
  }

  componentDidUpdate(prevProps) {
    if (this.isUpdating) {
      return
    }

    const a = this.props
    const b = prevProps

    if (a.min === b.min && a.max === b.max && a.value === b.value && a.step === b.step) {
      return
    }

    if (Number.isNaN(this.props.value)) {
      return
    }

    this.isUpdating = true

    this.setState({
      min: this.props.min || 0,
      max: this.props.max || 100,
      step: this.props.step || 1,
      textValue: (this.props.value && this.props.value.toString()) || '0',
      sliderValue: this.props.value || 0,
      isInvalid: false
    })

    this.isUpdating = false
  }

  handleSliderValueChange(value: number) {
    const valueAsNumber = Number(value)
    const textValue = value.toString()
    this.setState({ sliderValue: valueAsNumber, textValue, isInvalid: false })

    if (this.props.onChange) {
      this.props.onChange(textValue)
    }
  }

  handleTextInputChange(value: string) {
    // is it a number?
    // is it within range
    // does it meet the step requirements?
    // if all yes, then update the slider
    // if no, then set isError on the TextInput
    const { max, min, step } = this.state

    const valueAsNumber = Number(value)

    if (Number.isNaN(valueAsNumber)) {
      this.setState({
        isInvalid: true,
        textValue: value
      })

      if (this.props.onChange) {
        this.props.onChange(value)
      }
      return
    }

    if (valueAsNumber < min || valueAsNumber > max) {
      this.setState({
        isInvalid: true,
        textValue: value
      })
      return
    }

    // valueAsNumber = 5.1
    // step = 0.1
    const quotient = valueAsNumber / step
    if (!Number.isInteger(quotient)) {
      this.setState({
        isInvalid: true,
        textValue: value
      })
      return
    }

    this.setState({
      isInvalid: false,
      textValue: value,
      sliderValue: valueAsNumber
    })

    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  render() {
    const { state } = this

    return (
      <Wrapper>
        <SliderWrapper>
          <Slider
            data-testid={`${this.props['data-testid']}-slider`}
            max={state.max}
            min={state.min}
            step={state.step}
            value={state.sliderValue}
            onChange={val => this.handleSliderValueChange(val)}
          />
        </SliderWrapper>
        <TextInputWrapper>
          <StyledTextInput
            readOnly
            data-testid={`${this.props['data-testid']}-text`}
            isError={state.isInvalid}
            value={state.textValue}
            onChange={e => this.handleTextInputChange(e.target.value)}
          />
        </TextInputWrapper>
      </Wrapper>
    )
  }
}
